export const tickerItems = [
  "黑料总站发布页 · 本页为永久地址，建议立即收藏",
  "2026.09.11 三条备用线路已同步上线，主站访问异常时可一键切换",
  "黑料总站镜像站测速公示：移动专线延迟 33ms，为当前最快通道",
  "黑料总站防走丢提示：请勿通过第三方短链进入，谨防仿冒页面",
  "本月累计更新入口 6 条，历史失效地址已全部归档",
];

export const channels = [
  {
    id: "main",
    name: "主站线路",
    tag: "推荐",
    host: "hlzz-main.pub",
    status: "正常",
    statusType: "ok",
    latency: "28ms",
    note: "日常访问首选，内容更新最及时",
  },
  {
    id: "backup-a",
    name: "备用线路 A",
    tag: "备用",
    host: "hlzz-a-mirror.cc",
    status: "正常",
    statusType: "ok",
    latency: "42ms",
    note: "主站无法打开时优先切换",
  },
  {
    id: "backup-b",
    name: "备用线路 B",
    tag: "备用",
    host: "hlzz-b-mirror.cc",
    status: "正常",
    statusType: "ok",
    latency: "55ms",
    note: "与线路 A 分流，高峰期更稳",
  },
  {
    id: "mobile",
    name: "移动专线",
    tag: "移动端",
    host: "hlzz-mobile.cc",
    status: "正常",
    statusType: "ok",
    latency: "33ms",
    note: "为手机端单独优化，节省流量",
  },
  {
    id: "mirror",
    name: "镜像站点",
    tag: "镜像",
    host: "hlzz-image.io",
    status: "轻微波动",
    statusType: "warn",
    latency: "78ms",
    note: "内容与主站同步，偶有延迟",
  },
  {
    id: "oversea",
    name: "海外线路",
    tag: "境外",
    host: "hlzz-global.io",
    status: "正常",
    statusType: "ok",
    latency: "121ms",
    note: "为境外访问者准备的独立通道",
  },
];

export const stickyAddress = {
  label: "永久地址",
  host: "hlzz-forever.pub",
  hint: "永久地址长期有效，不会随主站域名轮换而失效，是黑料总站防走丢的核心入口。",
};

export const updateNotes = [
  {
    id: "n1",
    kind: "线路维护",
    date: "2026.09.11",
    title: "发布页三条备用线路同步上线，主站异常时响应更快",
    summary:
      "本次更新为黑料总站发布页补充了备用线路 A、B 与移动专线，测速结果均已公示。线路切换入口统一收拢在本页顶部入口条，点击即可复制或打开，无需再逐条记忆地址。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20still%20life%20on%20a%20cream%20linen%20surface%2C%20a%20folded%20newspaper%2C%20brass%20desk%20lamp%20and%20vintage%20camera%20arranged%20with%20generous%20negative%20space%2C%20soft%20directional%20daylight%2C%20muted%20crimson%20and%20gold%20accents%2C%20refined%20magazine%20photography%2C%20subtle%20shadows%2C%20calm%20sophisticated%20mood&width=1200&height=900&seq=update-large-01&orientation=landscape",
    featured: true,
  },
  {
    id: "n2",
    kind: "域名说明",
    date: "2026.09.06",
    title: "为什么地址会轮换：黑料总站新地址的由来",
    summary:
      "域名调整是为了保障稳定访问，本页会第一时间同步黑料总站新地址，收藏本页即可自动获知。",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20flat%20lay%20of%20cream%20paper%20cards%20with%20a%20crimson%20wax%20seal%20and%20gold%20pen%20on%20a%20warm%20beige%20background%2C%20soft%20overhead%20daylight%2C%20refined%20stationery%20photography%2C%20generous%20negative%20space%2C%20elegant%20magazine%20styling&width=800&height=600&seq=update-sm-01&orientation=landscape",
    featured: false,
  },
  {
    id: "n3",
    kind: "测速公示",
    date: "2026.09.02",
    title: "本月线路测速结果公示，移动端表现最佳",
    summary:
      "六条通道完成一轮完整测速，移动专线以 33ms 居首，镜像站出现轻微波动已记录待观察。",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20brass%20key%20resting%20on%20folded%20cream%20paper%20with%20golden%20ink%20lines%2C%20warm%20directional%20light%2C%20muted%20amber%20and%20ivory%20tones%2C%20minimal%20editorial%20still%20life%20photography%2C%20sophisticated%20print%20aesthetic%2C%20soft%20shadows&width=800&height=600&seq=update-sm-02&orientation=landscape",
    featured: false,
  },
  {
    id: "n4",
    kind: "使用技巧",
    date: "2026.08.28",
    title: "把发布页加入书签，三步完成防走丢设置",
    summary:
      "浏览器书签、手机桌面快捷方式与永久地址备忘，是黑料总站防走丢最有效的三种做法。",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20cream%20envelopes%20tied%20with%20a%20deep%20red%20ribbon%20on%20a%20warm%20beige%20desk%2C%20soft%20morning%20light%2C%20muted%20crimson%20accent%2C%20minimal%20editorial%20still%20life%2C%20refined%20magazine%20photography%2C%20generous%20negative%20space&width=800&height=600&seq=update-sm-03&orientation=landscape",
    featured: false,
  },
  {
    id: "n5",
    kind: "归档记录",
    date: "2026.08.21",
    title: "历史失效地址统一归档，旧链接不再维护",
    summary:
      "为避免误入仿冒页面，已失效的黑料总站备用地址全部移入归档区，请以本页展示的通道为准。",
    image:
      "https://readdy.ai/api/search-image?query=Old%20wall%20clock%20and%20a%20cream%20notebook%20on%20a%20warm%20wooden%20surface%2C%20soft%20window%20light%2C%20muted%20gold%20and%20ivory%20palette%2C%20calm%20editorial%20still%20life%20photography%2C%20generous%20negative%20space%2C%20sophisticated%20minimal%20styling&width=800&height=600&seq=update-sm-04&orientation=landscape",
    featured: false,
  },
];

export const collections = [
  {
    id: "c1",
    no: "01",
    name: "封面专题合集",
    count: "128 篇",
    desc: "按期刊体例整理的封面级内容，阅读节奏偏慢，适合完整翻阅。",
    tone: "primary",
  },
  {
    id: "c2",
    no: "02",
    name: "月度索引总表",
    count: "24 期",
    desc: "每月一页，把当月更新的条目、线路变动与公告统一编号归档。",
    tone: "accent",
  },
  {
    id: "c3",
    no: "03",
    name: "深度整理合集",
    count: "86 篇",
    desc: "长文与脉络梳理为主，信息密度较低，留白充足，适合慢读。",
    tone: "secondary",
  },
  {
    id: "c4",
    no: "04",
    name: "新人指路合集",
    count: "32 篇",
    desc: "第一次访问的必读集合，讲清入口规则、访问方式与常见疑问。",
    tone: "primary",
  },
  {
    id: "c5",
    no: "05",
    name: "归档回溯合集",
    count: "210 条",
    desc: "收录历史地址与已下线内容编号，仅作回溯查询使用。",
    tone: "secondary",
  },
];

export const guides = [
  {
    id: "g1",
    step: "第一步",
    title: "收藏本发布页",
    desc: "把黑料总站发布页加入浏览器书签或手机桌面，地址轮换时可第一时间回到这里。",
    icon: "ri-bookmark-3-line",
  },
  {
    id: "g2",
    step: "第二步",
    title: "记录永久地址",
    desc: "永久地址不随主站域名变化而失效，抄写或截图保存一份，是最稳的黑料总站防走丢方案。",
    icon: "ri-anchor-line",
  },
  {
    id: "g3",
    step: "第三步",
    title: "关注发布频道",
    desc: "发布频道会推送黑料总站新地址与线路状态，遇到访问异常时可在频道内确认最新通道。",
    icon: "ri-notification-3-line",
  },
  {
    id: "g4",
    step: "第四步",
    title: "先切线路再等待",
    desc: "打不开通常只是单条通道波动，先切换备用线路或镜像站，多数情况可立即恢复访问。",
    icon: "ri-swap-box-line",
  },
];

export const faqs = [
  {
    id: "f1",
    q: "为什么黑料总站偶尔会打不开？",
    a: "多数情况下是单条线路临时波动，而非站点本身停止服务。遇到这种情况建议先切换到备用线路 A 或 B，再查看本页顶部的状态条确认线路健康度。",
  },
  {
    id: "f2",
    q: "永久地址和备用地址有什么区别？",
    a: "永久地址是一条长期不变的特殊地址，本身不承载内容，只负责指向当前可用入口，因此不会随主站域名轮换而失效；备用地址则是主站之外可直接访问的平行通道。",
  },
  {
    id: "f3",
    q: "黑料总站新地址大概多久更新一次？",
    a: "没有固定周期，通常在域名调整或线路维护时同步更新。本页会第一时间记录，收藏本页后无需手动搜索黑料总站新地址。",
  },
  {
    id: "f4",
    q: "镜像站和主站的内容是一样的吗？",
    a: "镜像站内容与主站保持同步，只是同步存在少量延迟。如果发现镜像站内容更新时间较早，通常等待片刻或改用主站线路即可。",
  },
  {
    id: "f5",
    q: "怎样区分真正的发布页和仿冒页面？",
    a: "真正的发布页只会展示通道信息与状态记录，不会要求填写账号密码或下载来历不明的文件。凡是通过短链跳转、页面结构粗糙的地址，都建议放弃访问。",
  },
];

export const statusMeta = {
  updatedAt: "2026.09.11 09:30",
  issue: "ISSUE 04",
  activeChannel: "主站线路",
  totalChannels: "6 条通道在线",
};